import React, {PropTypes} from 'react';
import './input_component.less';
import validate from '../../util/validate';

export default class InputComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value : this.props.value || ""
    }
  }
  componentWillReceiveProps(newProps){
    this.setState({
      value : newProps.value || ""
    })
  }
  inputChangeHandler = (e) =>{
    if(this.props.dollar)
    {
      if(validate.validAmount(e.target.value)){
        this.setState({
          value : e.target.value
        })
        this.props.changeHandler(this.props.for , e.target.value)
      }
    }
    else{
      this.setState({
        value : e.target.value
      })
      this.props.changeHandler(this.props.for , e.target.value)
    }
  }
  render() {
    const {props,state} = this;
    return (
      <div className = "input-component-wrap">
        <div className = "title">
          {props.title}
        </div>
          {
            props.dollar &&   <div className = "input-component">
            <span className ="dollar-elem">$</span> <input type={props.type} onChange ={this.inputChangeHandler} value = {this.state.value}className ="input dollar-padding" placeholder = {props.placeholder} />
            </div>
          }
          {
            !props.dollar &&   <div className = "input-component">
            <input type={props.type} onChange ={this.inputChangeHandler} value = {this.state.value}className ="input" placeholder = {props.placeholder} />
            </div>
          }
      </div>
    )
  }
}

InputComponent.propTypes = {
  title : React.PropTypes.string.isRequired,          //title for the input component
  value : React.PropTypes.any,                        //initial value for the input component
  placeholder : React.PropTypes.string.isRequired,    //placeholder for the component
  for : React.PropTypes.any.isRequired,                //unique id for the component e.g., state name in parent component
  changeHandler : React.PropTypes.func.isRequired,     //returns for and new value for the component
  type : React.PropTypes.string.isRequired,            //input type for the input box -text or number
  dollar : React.PropTypes.bool.isRequired              //dollar is show and validated using validAmount
};



// WEBPACK FOOTER //
// app/components/input_component/input_component.jsx